module.exports = __webpack_public_path__ + "img/u30876.8a3ab51e.png";